export default function R_StudyPlan() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_StudyPlan Component</h1>
      <p>This is the R_StudyPlan tutorial section.</p>
    </div>
  );
}
